import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge, Button, Form, Flex } from 'antd';
import { FilterOutlined } from '@ant-design/icons';
import { useTransportMileageFiltersStore } from 'shared/stores/use-transport-mileage-filters.ts';
import { TransportMileageDatepicker } from 'components/transport-mileage/transport-mileage-datepicker';
import { TransportMileageFiltersDrawer } from 'components/transport-mileage/transport-mileage-filters-drawer/transport-mileage-filters-drawer.tsx';
import { TransportMileageSearch } from './components/transport-mileage-search';

export const TransportMileageFilters = () => {
  const { filters, search } = useTransportMileageFiltersStore();
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [form] = Form.useForm();

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  const haveActiveFiltersInDrawer = Object.entries(filters || {}).some(([key, value]) => {
    if (key === 'date') return false;
    return !!value;
  });

  return (
    <>
      <Flex gap='small' align='stretch'>
        <TransportMileageDatepicker key='date-picker' form={form} />
        <TransportMileageSearch />
        <Badge key='filter-button' dot={haveActiveFiltersInDrawer}>
          <Button type='primary' icon={<FilterOutlined />} disabled={!!search} ghost onClick={handleOpen}>
            {t('common:filters')}
          </Button>
        </Badge>
      </Flex>
      <TransportMileageFiltersDrawer
        key='form-drawer'
        form={form}
        isOpen={isOpen}
        showClearFiltersButton={haveActiveFiltersInDrawer}
        onClose={handleClose}
      />
    </>
  );
};
